const o = "_root_kmol4_1", t = "_zapCard_kmol4_17", a = "_withLargeImage_kmol4_46", e = "_fullWidth_kmol4_50", _ = "_responsive_kmol4_55", n = "_small_kmol4_62", l = "_large_kmol4_67", s = "_topOfCard_kmol4_78", r = "_imageContainer_kmol4_88", m = "_withAppIcons_kmol4_103", c = "_serviceIconWrapper_kmol4_110", i = "_metadataWrapper_kmol4_120", k = "_title_kmol4_138", p = "_tag_kmol4_202", g = "_tagIcons_kmol4_209", d = "_tagText_kmol4_216", h = "_hideOnMobile_kmol4_221", C = "_skeletonRoot_kmol4_229", I = "_bookmarkButtonContainer_kmol4_234", b = "_tagLabel_kmol4_246", W = {
  root: o,
  zapCard: t,
  withLargeImage: a,
  fullWidth: e,
  responsive: _,
  small: n,
  large: l,
  topOfCard: s,
  imageContainer: r,
  withAppIcons: m,
  serviceIconWrapper: c,
  metadataWrapper: i,
  title: k,
  tag: p,
  tagIcons: g,
  tagText: d,
  hideOnMobile: h,
  skeletonRoot: C,
  bookmarkButtonContainer: I,
  tagLabel: b
};
export {
  W as s
};
//# sourceMappingURL=TemplateCard.module-Dp39N9oY.mjs.map
